/* global wpApiSettings */
import { createAsyncThunk } from "@reduxjs/toolkit";
import { wpBase } from "../api/base";
import { setUser } from "../slices/favorites.slice";

// CURRENT LOGGED IN USER
const fetchCurrUser = createAsyncThunk(
  "user/fetch",
  async (_, { dispatch, rejectWithValue }) => {
    try {
      const response = await wpBase.get(`/wp-json/wp/v2/users/me`, {
        headers: {
          "Content-Type": "application/json",
          "X-WP-Nonce": wpApiSettings.nonce,
        },
      });

      if (response.status === 200 || response.status === 201) {
        dispatch(setUser(response.data));
        return response.data;
      } else {
        return rejectWithValue(`Unexpected status code: ${response.status}`);
      }
    } catch (error) {
      console.error("Error fetching user data:", error);
      return rejectWithValue(error.message);
    }
  }
);

export { fetchCurrUser };
